import Tooltip from "@atlaskit/tooltip";
import type {ComponentProps} from "react";

export function AnankeTooltip(props: ComponentProps<typeof Tooltip>) {
    return <Tooltip {...props} />;
}
